// extracted by mini-css-extract-plugin
module.exports = {"form":"footerForm_form__4Yzr6","button":"footerForm_button__St0Hj"};